<template>
  <div>
    <Create :create="createItem" :close="closeCreate"></Create>
    <NavBar />
    <div class="container">
      <SideBar />
      <div class="content">
        <div class="content-wrapper">
          <Loading :isActive="loading"></Loading>
          <h1 class="title">
            <svg
              version="1.1"
              id="Capa_1"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              x="0px"
              y="0px"
              viewBox="0 0 32 32"
              style="enable-background: new 0 0 32 32"
              xml:space="preserve"
            >
              <path
                d="M28,7V3H0v22c0,0,0,4,4,4h25c0,0,3-0.062,3-4V7H28z M4,27c-2,0-2-2-2-2V5h24v20 c0,0.921,0.284,1.559,0.676,2H4z"
              ></path>
              <rect x="4" y="9" width="20" height="2"></rect>
              <rect x="15" y="21" width="7" height="2"></rect>
              <rect x="15" y="17" width="9" height="2"></rect>
              <rect x="15" y="13" width="9" height="2"></rect>
              <rect x="4" y="13" width="9" height="10"></rect>
            </svg>
            Avisos
          </h1>
          <ul class="tabs">
            <li class="tab-active">
              <router-link to="/noticias">Avisos</router-link>
            </li>
          </ul>
          <div class="card">
            <div class="card-body">
              <div class="filters row">
                <div class="col-1">
                  <span class="filters__search">
                    <input
                      type="text"
                      name
                      value
                      placeholder="Buscar por..."
                      v-model="termo"
                    />
                    <img
                      style="position: relative; top: -7px; right: -10px"
                      src="data:image/svg+xml;utf8;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMTkuMC4wLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4PSIwcHgiIHk9IjBweCIgdmlld0JveD0iMCAwIDU2Ljk2NiA1Ni45NjYiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDU2Ljk2NiA1Ni45NjY7IiB4bWw6c3BhY2U9InByZXNlcnZlIiB3aWR0aD0iMTZweCIgaGVpZ2h0PSIxNnB4Ij4KPHBhdGggZD0iTTU1LjE0Niw1MS44ODdMNDEuNTg4LDM3Ljc4NmMzLjQ4Ni00LjE0NCw1LjM5Ni05LjM1OCw1LjM5Ni0xNC43ODZjMC0xMi42ODItMTAuMzE4LTIzLTIzLTIzcy0yMywxMC4zMTgtMjMsMjMgIHMxMC4zMTgsMjMsMjMsMjNjNC43NjEsMCw5LjI5OC0xLjQzNiwxMy4xNzctNC4xNjJsMTMuNjYxLDE0LjIwOGMwLjU3MSwwLjU5MywxLjMzOSwwLjkyLDIuMTYyLDAuOTIgIGMwLjc3OSwwLDEuNTE4LTAuMjk3LDIuMDc5LTAuODM3QzU2LjI1NSw1NC45ODIsNTYuMjkzLDUzLjA4LDU1LjE0Niw1MS44ODd6IE0yMy45ODQsNmM5LjM3NCwwLDE3LDcuNjI2LDE3LDE3cy03LjYyNiwxNy0xNywxNyAgcy0xNy03LjYyNi0xNy0xN1MxNC42MSw2LDIzLjk4NCw2eiIgZmlsbD0iIzAwNDE2ZiIvPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8L3N2Zz4K"
                    />
                  </span>
                </div>
              </div>
              <table class="table">
                <thead>
                  <tr>
                    <th>
                      Tam:
                      <span class="label primary">400 x 400</span>
                    </th>
                    <th>Título</th>
                    <th>Dt Inicial</th>
                    <th>Dt Final</th>
                    <th>Ativo</th>
                    <th>Público</th>
                    <th>
                      <button
                        class="button button-success button-sm button-block"
                        v-on:click="openCreate()"
                      >
                        <svg
                          style="width: 12px; height: 12px; fill: #fff"
                          x="0px"
                          y="0px"
                          viewBox="0 0 42 42"
                        >
                          <path
                            d="M37.059,16H26V4.941C26,2.224,23.718,0,21,0s-5,2.224-5,4.941V16H4.941C2.224,16,0,18.282,0,21s2.224,5,4.941,5H16v11.059 C16,39.776,18.282,42,21,42s5-2.224,5-4.941V26h11.059C39.776,26,42,23.718,42,21S39.776,16,37.059,16z"
                          ></path>
                        </svg>
                        Novo
                      </button>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(i, index) in filtered()" v-bind:key="index">
                    <td>
                      <div class="imgbox" v-if="i.img.length > 0">
                        <span>
                          <button
                            class="button button-error button-sm"
                            v-on:click="deleteImg(i)"
                          >
                            <svg
                              style="
                                margin-top: 4px;
                                width: 12px;
                                height: 12px;
                                fill: #fff;
                              "
                              x="0px"
                              y="0px"
                              viewBox="0 0 459 459"
                            >
                              <g>
                                <path
                                  d="M76.5,408c0,28.05,22.95,51,51,51h204c28.05,0,51-22.95,51-51V102h-306V408z M408,25.5h-89.25L293.25,0h-127.5l-25.5,25.5 H51v51h357V25.5z"
                                ></path>
                              </g>
                            </svg>
                          </button>
                          <img :src="getImage(i.img[0])" />
                        </span>
                      </div>
                      <div class="imgbox" v-else>
                        <span>
                          <label class="button button-sm button-success">
                            <svg
                              style="
                                float: left;
                                width: 18px;
                                height: 18px;
                                fill: #fff;
                              "
                              x="0px"
                              y="0px"
                              viewBox="0 0 612 612"
                            >
                              <g>
                                <path
                                  d="M494.7,255C476.85,168.3,400.35,102,306,102c-73.95,0-137.7,40.8-168.3,102C58.65,214.2,0,277.95,0,357 c0,84.15,68.85,153,153,153h331.5c71.4,0,127.5-56.1,127.5-127.5C612,316.2,558.45,260.1,494.7,255z M357,331.5v102H255v-102 h-76.5L306,204l127.5,127.5H357z"
                                ></path>
                              </g>
                            </svg>
                            <input
                              type="file"
                              name="img"
                              style="display: none"
                              accept="image/jpg, image/jpeg, image/png, image/webp"
                              @change="handleUpload(i)"
                            />
                          </label>
                        </span>
                      </div>
                    </td>
                    <td>{{ i.titulo }}</td>
                    <td>
                      <span class="label success">{{ i.dtIni }}</span>
                    </td>
                    <td>
                      <span class="label success">{{ i.dtFim }}</span>
                    </td>
                    <td>
                      <span class="label success" v-if="i.ativo">Ativo</span>
                      <span class="label error" v-else>Inativo</span>
                    </td>
                    <td>
                      <span class="label primary">{{ i.publico }}</span>
                    </td>
                    <td class="actions">
                      <router-link
                        :to="'/noticia/' + i._id"
                        class="button button-primary"
                      >
                        <svg
                          x="0px"
                          y="0px"
                          style="
                            margin-top: 4px;
                            width: 12px;
                            height: 12px;
                            fill: #fff;
                          "
                          viewBox="0 0 485.219 485.22"
                        >
                          <g>
                            <path
                              d="M467.476,146.438l-21.445,21.455L317.35,39.23l21.445-21.457c23.689-23.692,62.104-23.692,85.795,0l42.886,42.897 C491.133,84.349,491.133,122.748,467.476,146.438z M167.233,403.748c-5.922,5.922-5.922,15.513,0,21.436 c5.925,5.955,15.521,5.955,21.443,0L424.59,189.335l-21.469-21.457L167.233,403.748z M60,296.54c-5.925,5.927-5.925,15.514,0,21.44 c5.922,5.923,15.518,5.923,21.443,0L317.35,82.113L295.914,60.67L60,296.54z M338.767,103.54L102.881,339.421 c-11.845,11.822-11.815,31.041,0,42.886c11.85,11.846,31.038,11.901,42.914-0.032l235.886-235.837L338.767,103.54z M145.734,446.572c-7.253-7.262-10.749-16.465-12.05-25.948c-3.083,0.476-6.188,0.919-9.36,0.919 c-16.202,0-31.419-6.333-42.881-17.795c-11.462-11.491-17.77-26.687-17.77-42.887c0-2.954,0.443-5.833,0.859-8.703 c-9.803-1.335-18.864-5.629-25.972-12.737c-0.682-0.677-0.917-1.596-1.538-2.338L0,485.216l147.748-36.986 C147.097,447.637,146.36,447.193,145.734,446.572z"
                            ></path>
                          </g>
                        </svg> </router-link
                      >&nbsp;
                      <button
                        class="button button-error"
                        v-on:click="deleteItem(i, index)"
                      >
                        <svg
                          style="
                            margin-top: 4px;
                            width: 12px;
                            height: 12px;
                            fill: #fff;
                          "
                          x="0px"
                          y="0px"
                          viewBox="0 0 459 459"
                        >
                          <g>
                            <path
                              d="M76.5,408c0,28.05,22.95,51,51,51h204c28.05,0,51-22.95,51-51V102h-306V408z M408,25.5h-89.25L293.25,0h-127.5l-25.5,25.5 H51v51h357V25.5z"
                            ></path>
                          </g>
                        </svg>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { get, post, put, del, uploadImage } from "@/helpers/apiRequest";
import { getImage } from "@/helpers/utils";
import Create from "./Create";
// import Edit from './Edit'

const urlList = "/noticias";
const url = "/noticia";

export default {
  name: "config",
  components: {
    Create,
  },
  data() {
    return {
      loading: false,
      termo: "",
      items: [],
      currentItem: {},
    };
  },
  methods: {
    getImage: getImage,
    deleteItem(item, index) {
      const { _id } = item;
      this.$swal({
        title: "Confirma Remover ?",
        showCancelButton: true,
        type: "error",
        confirmButtonColor: "#d82727",
      }).then(
        () => {
          this.loading = true;
          del(`${url}/${_id}`).then((json) => {
            this.items = this.items.filter((_, k) => +index !== +k);
            this.loading = false;
          });
        },
        () => {}
      );
    },
    openCreate() {
      this.$modal.show("noticiaCreate");
    },
    closeCreate() {
      this.$modal.hide("noticiaCreate");
    },
    createItem(titulo, resumo, publico) {
      post(url, { titulo, resumo, publico })
        .then((json) => {
          this.loading = false;
          this.$swal({
            title: "Inserido com Sucesso",
            type: "success",
            type: "success",
          });
          this.items.push(json);
        })
        .catch((err) => console.log("err", err));
    },
    handleUpload(item) {
      event.preventDefault();
      const settings = {
        el: event.target,
        str: `/noticias/img/${item._id}`,
        dim: "400x400",
      };
      this.loading = true;
      uploadImage(settings)
        .then(({ filename }) => {
          item.img = [filename];
          this.loading = false;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    deleteImg(item) {
      this.$swal({
        title: "Confirma Remover ?",
        showCancelButton: true,
        type: "error",
        confirmButtonColor: "#d82727",
      }).then(
        () => {
          this.loading = true;
          del(`/upload/noticias/img/${item._id}/0`)
            .then((json) => {
              item.img = [];
              this.loading = false;
            })
            .catch((err) => {
              console.log(err);
            });
        },
        () => {}
      );
    },
    filtered() {
      return this.items
        .filter((i) =>
          ["titulo"].some((k) =>
            i[k].toLowerCase().match(this.termo.toLowerCase())
          )
        )
        .sort((a, b) => (a.ordem > b.ordem ? 1 : a.ordem < b.ordem ? -1 : 0));
    },
  },
  beforeMount() {
    this.loading = true;
    get(urlList)
      .then((json) => {
        this.loading = false;
        this.items = json;
      })
      .catch((err) => console.log("err", err));
  },
};
</script>



// WEBPACK FOOTER //
// src/views/Noticias/Noticias.vue